var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_686:26233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3C8.37054 3 3 8.37054 3 15C3 21.6295 8.37054 27 15 27C21.6295 27 27 21.6233 27 15C27 8.37674 21.6233 3 15 3ZM23.1798 18.8946C21.7535 19.9612 20.3643 20.6124 19 21.0341C18.6651 20.569 18.3612 20.0791 18.107 19.5581C18.5969 19.3721 19.0744 19.1426 19.5209 18.8698C19.4394 18.8097 19.3608 18.7467 19.2812 18.6827L19.2811 18.6827C19.2456 18.6542 19.2099 18.6256 19.1736 18.5969C16.4884 19.8682 13.5364 19.8682 10.8202 18.5969C10.7085 18.6899 10.5907 18.7829 10.4729 18.8698C10.9194 19.1364 11.3907 19.3659 11.8806 19.5581C11.6202 20.0791 11.3225 20.569 10.9876 21.0341C9.62326 20.6124 8.24031 19.9612 6.81395 18.8946C6.52248 15.7628 7.10543 12.5876 9.26357 9.33178C10.3302 8.82946 11.4775 8.46357 12.6744 8.25891C12.8233 8.52558 12.9969 8.87907 13.1147 9.16434C14.3612 8.97209 15.6202 8.97209 16.8915 9.16434C17.0093 8.87907 17.1829 8.52558 17.3256 8.25891C18.5225 8.46357 19.6636 8.82946 20.7302 9.33178C22.5969 12.1163 23.5271 15.2667 23.1798 18.8946ZM17.7416 13.5921C16.9106 13.5921 16.2594 14.3549 16.2594 15.2789C16.2594 16.203 16.9292 16.9657 17.7416 16.9657C18.5726 16.9657 19.2238 16.203 19.2238 15.2789C19.2424 14.3549 18.5726 13.5921 17.7416 13.5921ZM10.7765 15.2789C10.7765 14.3549 11.4277 13.5921 12.2587 13.5921C13.0835 13.5921 13.7532 14.3549 13.7408 15.2789C13.7408 16.203 13.0897 16.9657 12.2587 16.9657C11.4463 16.9657 10.7765 16.203 10.7765 15.2789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_686:26233",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.760784 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_686:26233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_686:26233",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.2740124ea6a5cbd3feba69da6e30ab26.svg";
export { ForwardRef as ReactComponent };